export default {
  // Step 1
  step1: {
    text: "Step 1: In the DingTalk group ",
    settings: "Settings",
    text2: " float window, select ",
    addRobot: "Add Robot",
    text3: ", select ",
    custom: "Custom",
    text4: " robot",
  },

  // Step 2
  step2: {
    text: "Step 2: Click to confirm adding ",
    robot: "robot",
    text2: " security settings, check ",
    signatureVerification: "Signature Verification",
    text3: ", click confirm to complete DingTalk group robot configuration",
  },

  // Step 3
  step3: {
    text: "Step 3: After clicking to complete adding ",
    robot: "robot",
    text2:
      " successfully, in group settings -> group robot, find this robot and open information, you can copy DingTalk robot webhook and signature verification",
  },

  // Step 4
  step4: {
    text: "Step 4: Paste the copied DingTalk robot signature key and DingTalk robot Webhook to the corresponding options in address monitoring DingTalk",
  },
};
